export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "parseGridNftDataToCanvas.worker.04fbc55ec690953a155c.worker.js");
}
